module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/49ffc6d6acb0805bfc472c17f5586cb1.svg";